import { Component } from '@angular/core';
import { Skeleton } from 'excellence-ui';

@Component({
  selector: 'app-dashboard-summary-card-skeleton',
  imports: [Skeleton],
  templateUrl: './dashboard-summary-card-skeleton.html',
})
export class DashboardSummaryCardSkeleton {}
